import { AGEING_ACTION, ISSUE_DETAILS_ACTION } from "../constant";
import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { get } from "lodash";

export const getIssueDetails = (requestMethod = request, issueDetails) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.ISSUE_DETAILS_START
    });
    return requestMethod(apiServices.getIssueDetails(issueDetails))
      .then(issueDetails => {
        const payload = issueDetails.data;
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_DETAILS_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_DETAILS_FAILURE
        });
      });
  };
};

export const getIssueMeetingByIdAction = (requestMethod = request, issueId) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.ISSUE_MEETING_START
    });
    return requestMethod(apiServices.getIssueMeetingsById(issueId))
      .then(response => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_MEETING_SUCCESS,
          payload: {
            data: get(response, "data.data"),
            status: get(response, "data.status"),
            message: get(response, "data.message")
          }
        });
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_MEETING_FAILURE
        });
      });
  };
};

export const submitCommentOnIssue = (requestMethod = request, comments) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.SUBMIT_COMMENT_START
    });
    return requestMethod(apiServices.submitCommentOnIssueParams(comments))
      .then(comment => {
        const payload = comment.data;
        dispatch({
          type: ISSUE_DETAILS_ACTION.SUBMIT_COMMENT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.SUBMIT_COMMENT_FAILURE
        });
      });
  };
};

export const issueAgeingReport = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.ISSUE_AGEING_REPORT_START
    });
    return requestMethod(apiServices.issueAgeingReportParams(params))
      .then(issueAgeing => {
        const payload = issueAgeing.data;
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_AGEING_REPORT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_AGEING_REPORT_FAILURE
        });
      });
  };
};

export const upcomingMeetings = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.UPCOMING_MEETINGS_START
    });
    return requestMethod(apiServices.upcomingMeetingsParams(params))
      .then(upcomingMeetings => {
        const payload = upcomingMeetings.data;
        dispatch({
          type: ISSUE_DETAILS_ACTION.UPCOMING_MEETINGS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.UPCOMING_MEETINGS_FAILURE
        });
      });
  };
};

export const issueActivityHistory = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.ISSUE_ACTIVITY_HISTORY_START
    });
    return requestMethod(apiServices.issueActivityHistoryParams(params))
      .then(issueAgeing => {
        const payload = get(issueAgeing, "data", {});
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_ACTIVITY_HISTORY_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_ACTIVITY_HISTORY_FAILURE
        });
      });
  };
};

export const issueActivityComment = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ISSUE_DETAILS_ACTION.ISSUE_COMMENT_START
    });
    return requestMethod(apiServices.issueActivityCommentParams(params))
      .then(issueAgeing => {
        const payload = get(issueAgeing, "data", null);
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_COMMENT_SUCCESS
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: ISSUE_DETAILS_ACTION.ISSUE_COMMENT_FAILURE
        });
      });
  };
};

export const getAgeingAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: AGEING_ACTION.GET_AGEING_START
    });
    return requestMethod(apiServices.getAgeing(params))
      .then(response => {
        dispatch({
          type: AGEING_ACTION.GET_AGEING_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: AGEING_ACTION.GET_AGEING_FAILURE
        });
      });
  };
};

export const getAgeingTreeAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: AGEING_ACTION.GET_AGEING_START
    });
    return requestMethod(apiServices.getAgeingTree(params))
      .then(response => {
        dispatch({
          type: AGEING_ACTION.GET_AGEING_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: AGEING_ACTION.GET_AGEING_FAILURE
        });
      });
  };
};

export const getUpcomingMeetings = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: AGEING_ACTION.GET_UPCOMMING_MEETINGS_START
    });
    return requestMethod(apiServices.getUpCommingMeetings(params))
      .then(response => {
        dispatch({
          type: AGEING_ACTION.GET_UPCOMMING_MEETINGS_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: AGEING_ACTION.GET_UPCOMMING_MEETINGS_FAILURE
        });
      });
  };
};
